export const removeMimeType = (str) => str.slice(0, -4);